var _a;
var images_format_keys = {
    avif: "avif",
    heic: "heic",
    heif: "heif",
    jpeg: "jpeg",
    jpg: "jpg",
    png: "png",
    webp: "webp",
    gif: "gif",
    svg: "svg",
    tiff: "tiff",
};
var PNG_MIME_TYPE = "image/png";
var file_mime_types = (_a = {},
    _a[images_format_keys.avif] = ["image/avif"],
    _a[images_format_keys.heic] = ["image/heic"],
    _a[images_format_keys.heif] = ["image/heif"],
    _a[images_format_keys.jpeg] = ["image/jpeg"],
    _a[images_format_keys.jpg] = ["image/jpeg"],
    _a[images_format_keys.png] = [PNG_MIME_TYPE],
    _a[images_format_keys.webp] = ["image/webp"],
    _a[images_format_keys.gif] = ["image/gif"],
    _a[images_format_keys.svg] = ["image/svg+xml"],
    _a[images_format_keys.tiff] = ["image/tiff"],
    _a);

export { PNG_MIME_TYPE, file_mime_types, images_format_keys };
//# sourceMappingURL=File.constants.js.map
